import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ResendOtp, SendOtp, SendOtpResponse, VerifyOtp } from "../../models/login";
import { VerifyOtpResponse } from "@models/login.model";

@Injectable({
    providedIn: "root",
})
export class LoginPageService {
    constructor(private http: HttpClient) {}

    public sendOTP(body: SendOtp): Observable<SendOtpResponse> {
        return this.http.post<SendOtpResponse>(`${environment.apiUrlBasePath}/login/sendOtp`, body);
    }

    public verifyOtp(body: VerifyOtp): Observable<VerifyOtpResponse> {
        return this.http.post<VerifyOtpResponse>(`${environment.apiUrlBasePath}/login/verifyOtp`, body);
    }

    public resendOtp(body: ResendOtp): Observable<string> {
        return this.http.post<string>(`${environment.apiUrlBasePath}/login/resendOtp`, body);
    }
}
